var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.enable)?_c('div',{staticClass:"d-flex justify-content-center align-items-center",attrs:{"id":"hover"}},[_c('b-spinner',{attrs:{"variant":"primary"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }